<template>
    <div class="post">
        <div v-if="loading" class="loading">
            <div class="q-pa-md q-gutter-sm center_spinner" v-if="!firstload">                
                <q-inner-loading label="Please wait..." :showing="loading">
                    <q-spinner-gears size="50px" color="blue" />
                </q-inner-loading> 
            </div>
            <div v-if="firstload">
                <q-img src="background1.jpeg">
                <div class="absolute-full text-subtitle2 flex flex-center">
                    <q-card
                        class="home-card text-white"
                        style="background: radial-gradient(circle, #35a2ff 0%, #014a88 100%)"
                        >
                        <q-card-section>
                            <div class="text-h6">Loading Data....</div>
                            <div class="text-subtitle2">Please wait.</div>
                        </q-card-section>

                        <q-card-section class="q-pt-none">
                            If this page is not loaded within a minute, please contact "info [at] zadokcalendar.com". <br> I will try to have things sorted as soon as possible.
                        </q-card-section>
                    </q-card>
                </div>
                </q-img>
            </div>                       
        </div>
        <div v-if="!loading" class="content">
            <section>
                <div class="nav-bar"><h4>Zadok Calendar&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;{{ post.currentMonth.month == "13" ? "Intercalation" : "Month " + post.currentMonth.month }} - {{ post.currentMonth.year }}</h4></div>
                <div class="wrap">
                    <div class="outtertable">                        
                        <div class="calendar_row">
                            <div style="font-weight: bold;" class="outtertablecell">Day 1 <i style="font-size: x-small">(Sunday)</i></div>
                            <div style="font-weight: bold;" class="outtertablecell">Day 2 <i style="font-size: x-small">(Monday)</i></div>
                            <div style="font-weight: bold;" class="outtertablecell">Day 3 <i style="font-size: x-small">(Tuesday)</i></div>
                            <div style="font-weight: bold;" class="outtertablecell">Day 4 <i style="font-size: x-small">(Wednesday)</i></div>
                            <div style="font-weight: bold;" class="outtertablecell">Day 5 <i style="font-size: x-small">(Thursday)</i></div>
                            <div style="font-weight: bold;" class="outtertablecell">Day 6 <i style="font-size: x-small">(Friday)</i></div>
                            <div style="font-weight: bold;" class="outtertablecell sabbath">Day 7 <i style="font-size: x-small">(Saturday)</i></div>
                        </div>
                        <div v-for="week in post.weeks" :key="week.weekNumber" class="calendar_row">
                            <calendar-week :week="week"></calendar-week>
                        </div>
                        <div v-if="!showCalendarOnly" class="calendar_row">
                            <div class="cell"></div>
                            <div class="cell"></div>
                            <div class="cell"></div>
                            <div style="text-align: center" class="cell">
                                <button class="fal fa-arrow-alt-from-right fa-3x" ref="previous" @click="fetchData(post.previousMonth.year,post.previousMonth.month,layer)"></button>
                                <Datepicker class="Cal" v-model="currentDate" autoApply :flow="['year', 'month', 'calendar']" showNowButton nowButtonLabel="Today">
                                    <template #trigger>
                                        <button class="fal fa-calendar-alt fa-3x" ref="previous"></button>                                        
                                    </template>
                                </Datepicker>                                
                                <button class="fal fa-arrow-alt-from-left fa-3x" ref="next" @click="fetchData(post.nextMonth.year,post.nextMonth.month,layer)"></button>
                            </div>
                            <div class="cell"></div>
                            <div class="cell"></div>
                            <div class="cell"></div>
                        </div>
                    </div>
                </div>
                <div v-if="!showCalendarOnly" class="cursor-pointer" style="width: 100px">
                    <q-icon v-if="!editableDays" style="padding-left: 20px;" name="fal fa-book-open"/>
                    <q-icon v-if="!editableDays" style="padding-left: 20px;" name="fal fa-book-open-reader"/>
                    <q-popup-edit v-model="editWord" :cover="false" :offset="[0, 10]" v-slot="scope">
                    <q-input color="accent" v-model="scope.value" dense autofocus counter @keyup.enter="scope.set">
                        <template v-slot:prepend>
                        <q-icon name="record_voice_over" color="accent" />
                        </template>
                    </q-input>
                    </q-popup-edit>
                </div>
                <div v-if="verses && !showCalendarOnly">                                            
                    <div>{{ verses.reference }}</div>
                    <div v-for="verse in verses.verses" :key="verse.verse">
                        <i :verse="verse">({{verse.verse}}) {{verse.text}}</i>
                    </div>
                </div> 
            </section>
        </div>
    </div>      
</template>

<script>    
    const baseURL = "/api/";
    import { defineComponent } from 'vue';
    import CalendarWeek from './CalendarWeek.vue';
    import ZadokPlugin from '@/ZadokPlugin';  

    export default defineComponent({
        data() {
            return {
                editWord: "",
                editableDays: false,
                showCalendarOnly: false,
                loading: true,
                versusloading: true,
                moonphase: [],
                post: null,
                versus: null,                
                dayInfo: null,
                showLoader: false,
                firstload: false,
                token: "",
                currentDate: new Date(),
                bibleVerses: this.addVersesToArray()                
            };
        },
        mounted() {            
            console.log("currentDate=" + this.currentDate);
            this.firstload = true;
            
            //console.log($route.query.propertyName);
            this.fetchAllDefaultData();
        },
        props : ['year', 'month', 'layer', 'calendaronly'],
        watch: {
            // call again the method if the route changes
            '$route': 'fetchAllDefaultData',
            'currentDate': function(val){
                //console.log("Set new currentDate=" + this.currentDate + ' : val='+val);
                this.fetchDataByDate(val.toUTCString());
            },
            'editWord': function(val){
                this.fetchLoginToken(val)
                if (this.token != '')
                    this.editableDays = true;
                else this.editableDays = false;
            }

        },
        methods: {
            addVersesToArray(){
                var arrayObj = [];
                arrayObj = this.addtoArray(arrayObj,"John 3:16")
                arrayObj = this.addtoArray(arrayObj,"Psalm 37:5,6")
                return arrayObj
            },
            addtoArray(arrayObj, verse) {
                if (verse !== "") {
                    arrayObj.push(verse);                    
                    console.log("Added '" + verse + "' to bible versus array");
                } else {
                    console.log('The verse is empty')
                }
                return arrayObj
            },
            async fetchAllDefaultData() {       
                console.log("fetchAllDefaultData Called");
                console.log("Year - " + this.year + ": Month - " + this.month)
                this.loading = true;
                if (this.calendaronly && this.calendaronly == 1)
                    this.showCalendarOnly = true;
                if (this.year && this.month && this.layer)
                    await this.fetchData(this.year, this.month, this.layer)
                else if (this.year && this.month)
                    await this.fetchData(this.year, this.month)
                else
                    await this.fetchDefaultData(), 
                //setTimeout(() => this.loading = false, 10000)
                this.loading = false
            },
            async fetchDefaultData() {
                var useLayer = 1
                if (this.layer)                    
                    useLayer = this.layer;
                console.log("Loading Default Zadok Data");                        
                this.post = null;
                //this.loading = true;
                await this.fetchBibleVerse()
                fetch(`${baseURL}zadokdate/getMonthByCurrentDate/${useLayer}`)
                    .then(r => r.json())
                    .then(json => {
                        this.post = json;
                        this.getMoonPhases();
                        //this.loading = false;            
                        return;
                    });                
            },            
            async fetchData(year, month, layer) {
                if (!layer)
                    layer = 1;
                console.log("fetchData Called"); 
                //this.post = null;
                this.firstload = false;
                this.loading = true;
                this.showLoader = true;
                                
                await this.fetchBibleVerse();
                fetch(`${baseURL}zadokdate/getMonthByYearMonth/${layer}/${year}/${month}`)
                    .then(r => r.json())
                    .then(json => {
                        // setTimeout(() => this.loading = false, 500);                        
                        this.showLoader = false;
                        this.post = json;
                        this.getMoonPhases();
                        this.loading = false;
                    });                            
            },
            async fetchLoginToken(pswd) {
                console.log("fetchLoginToken Called"); 
                //this.post = null;     
                const options = {
                    method: "GET",
                    headers: {
                        "Connection" : "keep-alive",
                        "uid" : "Admin",
                        "pid" : pswd
                    }
                }                           
                await fetch(`${baseURL}zadokdate/getToken`, options)
                .then(r => r.text())
                .then(t => {
                    this.token = t,
                    this.editableDays = t.length > 0
                });
            },                        
            async fetchDataByDate(date) {
                console.log("fetchDataByDate Called"); 
                var useLayer = 1
                if (this.layer)                    
                    useLayer = this.layer;               
                this.post = null;
                this.loading = true;
                this.firstload = false;
                this.showLoader = true;
                await this.fetchBibleVerse();
                fetch(`${baseURL}zadokdate/getMonthByDate/${useLayer}/${date}`)
                    .then(r => r.json())
                    .then(json => {
                        this.post = json;
                        this.getMoonPhases();
                        //setTimeout(() => this.loading = false, 500);
                        this.loading = false;
                        return;
                    });
            },
            getMoonPhases() {
                if (this.post)
                {
                    this.firstday = this.post.days[0].gregorianDate;
                    this.lastday = this.post.days[this.post.days.length - 1].gregorianDate;
                    this.fetchMoonPhase(new Date(this.firstday).getFullYear(), new Date(this.firstday).getMonth()+1)
                    this.fetchMoonPhase(new Date(this.lastday).getFullYear(), new Date(this.lastday).getMonth()+1)
                }
            },
            async fetchBibleVerse() {
                console.log("Loading Bible Verse");          
                this.verses = null;
                this.versusloading = true;
                this.pickVerse = this.bibleVerses[Math.floor(Math.random() * this.bibleVerses.length)]                
                await fetch(`https://bible-api.com/${this.pickVerse}?transalation=psa`)
                //await fetch(`https://bible-api.com/${book}%20${chapter}:${verse}`)
                    .then(r => r.json())
                    .then(json => {
                        this.verses = json;
                        //this.versusloading = false;
                        return;
                    });
            },
            fetchMoonPhase(year, month) {
                console.log("Loading Moon Phase");          
                this.moonphase = null;
                
                fetch(`https://www.icalendar37.net/lunar/api/?lang=en&month=${month}&year=${year}&size=50&lightcolor=%22rgb(255,255,210)%22&shadeColor=%22black%22&texturize=false`)
                //await fetch(`https://bible-api.com/${book}%20${chapter}:${verse}`)
                    .then(r => r.json())
                    .then(json => {                        
                        this.moonloading = false;
                        var phaseValues = [].concat.apply([], ZadokPlugin.methods.getValues(json.phase));
                        for (var i=0; i<phaseValues.length; i++) {
                        // json.phase.forEach((p, index) => {
                            if (phaseValues[i].isPhaseLimit == 3 && phaseValues[i].phaseName == "Full moon")
                            {
                                if (this.moonphase == undefined)
                                    this.moonphase = []
                                this.moonphase.push({date:new Date(json.year, json.month, i), svg:phaseValues[i].svg, svgMini:phaseValues[i].svgMini});
                            }
                        }
                        return;
                    });                
            },
            async setDate(day) {
                console.log("Attempting to Save day")
                this.jsonText = JSON.stringify(day);
                await fetch(`${baseURL}zadokdate/setDate`,{
                    method:  'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'token': this.token
                    },
                    body: this.jsonText
                })
                    .then(response => response.json())
                    .then(json => {
                        day = json;                        
                    })
                    .then(
                        data => console.log(data)                        
                    )
                return day;
            } ,
            deleteDate(id) {
                console.log("Attempting to Delete ID:" + id)
                fetch(`${baseURL}zadokdate/deleteDate/${id}`,{
                    method: "DELETE",
                    headers: {
                        'token': this.token
                    }
                })
                    .then(r => r.json())
                    .then(()  => {
                        //this.post = json;
                        //this.loading = false;
                        return;
                    });
            } 

        },
        components: {
            CalendarWeek            
        },
    });
    
</script>

<style src="../../styles/css/all.min.css"></style>
<style>
body {
    background-color: #f2f2f2;    
    font-family: system-ui;
    position: relative;
}

.home-card {
  width: 75%;
  max-width: 950px;
}

.center_spinner {
    /* position:absolute; */
    background-color: #0d0d60;
    height: 600px;
    min-height: 600px;
}

.Cal{
    display: inline-block;
}

.wrap {
    /* flex-wrap: wrap; */
    width: 100%;
    margin: 0 auto;
    background: white;
    height: 100%;
    display: flex;
    min-height: 100%;
}

div.outtertable {
  /* display: table; */
  /* width: inherit; */
  /* table-layout:fixed; */
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  align-items: stretch;
  flex-grow: 1;
  align-self: stretch;
}

div.outtertablecell {
  /* display: table-cell; */
    border: 1px solid black;
    border-collapse: collapse;
    padding: 2px;
    text-align: center;
    height: 100%;
    /* background-color: yellow; */
    display: flex;
    align-self: stretch;
    width: 100%;
    align-items: flex-end;
    justify-content: space-between;
}

div.calendar_table {
  /* display: table;
  table-layout:fixed;   */
  display: flex;
  flex-direction: column;  
  align-self: stretch;
  height: 100%;
  align-items: stretch;

  width: inherit;
  padding-top: 4px;
  padding-bottom: 4px;
}

div.calendar_row {
    /* display: table-row; */
    display: flex;
    align-items: stretch;
    width: 100%;
    align-self: stretch;
    flex-direction: row;
    justify-content: center;
}

div.calendar_row_middle {
    /* display: table-row; */
    display: flex;
    align-items: stretch;
    width: 100%;
    align-self: stretch;
    flex-direction: row;
    flex-grow: 1;
}

div.calendar_row_bottom {
    /* display: table-row; */
    display: flex;
    align-items: flex-end;
    width: 100%;
    align-self: stretch;
}

div.cell {
  /* display: table-cell; */
  padding: 4px;
  align-items: baseline;
}

div.cell.colspan {
    display: none;
    /* collapse border */
    margin-top: -1px;
    margin-bottom: -1px;
}

.right-icons {
    margin-right: 3px !important;
}

.left-icons {
    margin-left: 3px !important;
}
.sabbath {
    background-color: peachpuff !important;
}

.feastday {
    background-color: paleturquoise;
}
/* 
.button {
    background-color: #39495c;
    border-radius: 5px;
    color: white;
    text-align: center;
} */

.nav-bar {
    margin-top: -50px !important;
    background: linear-gradient(-50deg, #010801, #0d0d60);
    height: 35px;
    margin-bottom: 5px;
    color:aliceblue;
    text-align: center;    
}
</style>